function Home() {
    return (
        <div>
            <h1>This is home</h1>
        </div>
    );
}

export default Home;
